import { ActionFunction } from 'react-router-dom'

import Collection from '@models/Collection'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const addCollectionAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  formData.delete('showSearch')
  return http.action.post<CollectionResponse>(ApiRoutes.collections.createPath(), formData)
}

export default addCollectionAction

export type CollectionResponse<I = unknown> = {
  collection: Collection<I>
}
